import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IMarketing } from 'src/app/domain/registration/models/IMarketing';
import { ISystem } from 'src/app/domain/registration/models/ISystem';
import { DynamicFormComponent } from 'src/app/shared/components/dynamic-form/containers/dynamic-form/dynamic-form.component';
import { SystemService } from '../../systems/crud-service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IPartner } from 'src/app/domain/registration/models/IPartner';
import { PartnerService } from '../../partners/crud-service';
import { PermissionService } from 'src/app/shared/permission.service';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';

@Component({
  selector: 'app-marketing-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
  providers: [SystemService, PartnerService],
})
export class MarketingCESComponent extends AbstractCrudCES<IMarketing> implements OnInit, OnDestroy {
  systemSelected: ISystem;
  marketing() {
    throw new Error('Method not implemented.');
  }
  i: any;
  showInfo(arg0: any, arg1: any) {
    throw new Error('Method not implemented.');
  }

  override data: IMarketing;
  typeSub: Subscription | undefined;
  partnerSub: Subscription | undefined;
  element: any;
  partnersSelected: any = [];
  override config: IFieldConfig[] = CES_CONFIG_FIELDS;


  setFields() {
    this.form.patchValue(this.data);

    if (this.data && this.data.system && typeof this.data.system === 'object') {
      this.systemSelected = this.data.system;
      this.form.get('system')?.setValue(this.data.system);
      this.form.get('partners')?.setValue(this.data.partners[0]);
    } 

  }

  constructor(
    public dialogRef: MatDialogRef<MarketingCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: IMarketing },
    private cdr: ChangeDetectorRef,
    public override fb: FormBuilder,
    private systemService: SystemService,
    private partnerService: PartnerService,
    public permissionService: PermissionService,
  ) {
    super(fb);
    this.typeCes = data.type;
    this.data = data.element;
    this.title = this.typeCes;
  }

  override ngOnInit(): void {
    this.form = this.createGroup();
    this.setFields();
  }


  ngOnDestroy(): void {
    this.typeSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: any) {
    value['type'] = SystemTypeIdEnum[value['type']];

    value['partners'] = this.partnersSelected?.map((partner: IPartner) => partner.id) ?? [];

    console.log('Enviando partners como array de strings:', value['partners']);
    console.log('Tipo de partners:', Array.isArray(value['partners']) ? 'array' : typeof value['partners']);
    if(value['system'] && typeof value['system'] === 'object' && value['system'].id){
        value['systemId'] = value['system'].id;
        value['system'] = value['system'].name;
    } 

    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.typeCes = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }

  selectPartners(event: any) {
    if (event && event.length > 0) {
      this.partnersSelected = event.map((partner: any) => ({
        id: partner.id,
        name: partner.name,
      }));
    } else {
      this.partnersSelected = [];
    }

    console.log("IDs dos parceiros selecionados:", this.partnersSelected.map((p: { id: any; }) => p.id));
  }

  protected changeTypeSystem(element:any){
    this.form.get('system')?.setValue(null);
    this.getFieldConfig('system').componentData = {
      params: { type: SystemTypeIdEnum[element] },
    };
  }
}
